import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl, EBaseUrl } from "../../../Helper/BaseUrl";
import { toastError } from "../../../Helper/ToastMessage";
// Get Table Data
export const EmployeeAttendanceGetTableDataAPI = createAsyncThunk("EmployeeAttendanceGetTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        M_DesignationID,
        M_EmployeeID,
        T_Encroach_SelfAttendanceID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Dashboard/Get_WEB_T_Encroach_EmployeeAttendance_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ZoneID=${M_ZoneID}&FromDate=${FromDate}&ToDate=${ToDate}&M_DesignationID=${M_DesignationID}&M_EmployeeID=${M_EmployeeID}&T_Encroach_SelfAttendanceID=${T_Encroach_SelfAttendanceID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const EmployeeAttendanceGetTableDataSlice = createSlice({
    name: "EmployeeAttendanceGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EmployeeAttendanceGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EmployeeAttendanceGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(EmployeeAttendanceGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const EmployeeAttendanceGetTableDataReducer = EmployeeAttendanceGetTableDataSlice.reducer

// Self Attenadance 

export const SelfAttendanceGetTableDataAPI = createAsyncThunk("SelfAttendanceGetTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        AttendanceDate,
        M_ZoneID,
        T_Encroach_SelfAttendanceID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
        handleGetExcel,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Dashboard/Get_WEB_T_Encroach_SelfAttendance_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ZoneID=${M_ZoneID}&AttendanceDate=${AttendanceDate}&T_Encroach_SelfAttendanceID=${T_Encroach_SelfAttendanceID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    handleGetExcel()
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const SelfAttendanceGetTableDataSlice = createSlice({
    name: "SelfAttendanceGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SelfAttendanceGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SelfAttendanceGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SelfAttendanceGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const SelfAttendanceGetTableDataReducer = SelfAttendanceGetTableDataSlice.reducer

export const SelfAttendanceGetExportTableDataAPI = createAsyncThunk("SelfAttendanceGetExportTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        AttendanceDate,
        M_ZoneID,
        T_Encroach_SelfAttendanceID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${EBaseUrl}/Dashboard/Get_WEB_T_Encroach_SelfAttendance_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ZoneID=${M_ZoneID}&AttendanceDate=${AttendanceDate}&T_Encroach_SelfAttendanceID=${T_Encroach_SelfAttendanceID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const SelfAttendanceGetExportTableDataSlice = createSlice({
    name: "SelfAttendanceGetExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SelfAttendanceGetExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(SelfAttendanceGetExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(SelfAttendanceGetExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastError('Something went wrong')
        });
    },
})

export const SelfAttendanceGetExportTableDataReducer = SelfAttendanceGetExportTableDataSlice.reducer